export default {"src":"/login-app/[GIT_HASH]/_next/static/media/execute.24fa447c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};